// src/components/TheoryExamplesRunner.js
import React, { useState } from "react";
import GraphViewer from "./GraphPlotter/GraphViewer";
import "katex/dist/katex.min.css";

// ✅ NEW: awaryjny poziomy scroll (auto, jeśli masz już poprawiony komponent)
import HorizontalScroll from "./ui/HorizontalScroll";

export default function TheoryExamplesRunner({ title, intro, examples }) {
  // Akordeon: jeden otwarty indeks lub null
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  // Separator dopasowany do motywu (tak jak w TaskRunnerze)
  const Hr = ({ mt = 24, mb = 24 }) => (
    <hr
      style={{
        marginTop: mt,
        marginBottom: mb,
        border: "none",
        borderTop: "2px solid",
        borderColor: "var(--color-text)",
        opacity: 1,
      }}
    />
  );

  const lastIdx = examples.length - 1;

  return (
    <div className="lesson-content">
      {/* separator na górze sekcji teorii */}
      <Hr mt={0} mb={24} />

      {title && <h2>{title}</h2>}

      {/* ✅ NEW: scroll dla teorii (intro) */}
      {intro && (
        <HorizontalScroll rightPadding={48}>
          <div>{intro}</div>
        </HorizontalScroll>
      )}

      {(title || intro) && <Hr />}

      {examples.map((ex, i) => {
        const isOpen = openIndex === i;

        // przy akordeonie wystarczy nie dublować pierwszego i ostatniego separatora
        const showTopSep = isOpen && i !== 0;
        const showBottomSep = isOpen && i !== lastIdx;

        return (
          <React.Fragment key={i}>
            {showTopSep && <Hr mt={12} mb={12} />}

            <div
              className="p-4 rounded bg-transparent"
              style={{ marginBottom: showBottomSep ? 0 : 24, border: "none" }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <h4 style={{ margin: 0 }}>{ex.label || `Przykład ${i + 1}`}</h4>
                  {ex.summary && (
                    <p style={{ fontStyle: "italic", fontSize: "0.9rem", opacity: 0.7, margin: "4px 0 0 0" }}>
                      {ex.summary}
                    </p>
                  )}
                </div>

                <button className="btn-secondary" onClick={() => toggle(i)}>
                  {isOpen ? "Ukryj" : "Pokaż"}
                </button>
              </div>

              {isOpen && (
                // ✅ NEW: jeden scroll dla całego przykładu
                <HorizontalScroll rightPadding={48} style={{ marginTop: 12 }}>
                  <div>
                    {ex.description && <div style={{ marginBottom: 12 }}>{ex.description}</div>}
                    {ex.points && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "16px 0",
                          ...(ex.graphContainerStyle || {}),
                        }}
                      >
                        <GraphViewer
                          points={ex.points}
                          segments={ex.segments || []}
                          width={ex.graphWidth}
                        />
                      </div>
                    )}
                    {ex.content && <div style={{ marginTop: 12 }}>{ex.content}</div>}
                  </div>
                </HorizontalScroll>
              )}
            </div>

            {showBottomSep && <Hr mt={12} mb={12} />}
          </React.Fragment>
        );
      })}

      <Hr />
    </div>
  );
}
